const e = "HorizontalSuiteCardBase-module_card__oeAD-",
  o = "HorizontalSuiteCardBase-module_image__iU0c9",
  r = "HorizontalSuiteCardBase-module_image-inner__BmZIL",
  t = "HorizontalSuiteCardBase-module_image-footer__hDqRa",
  a = "HorizontalSuiteCardBase-module_title__QvUs8",
  i = "HorizontalSuiteCardBase-module_features__yiQfd",
  l = "HorizontalSuiteCardBase-module_prices-column__237o5",
  n = "HorizontalSuiteCardBase-module_column-title__ohtGe",
  d = "HorizontalSuiteCardBase-module_prices__ed9-Y",
  _ = "HorizontalSuiteCardBase-module_price-item-inner__AQeYE",
  c = "HorizontalSuiteCardBase-module_price-item-wrapper__1QaI-",
  s = "HorizontalSuiteCardBase-module_price-item__Qu2CQ",
  u = "HorizontalSuiteCardBase-module_fare-label__4AaNg",
  m = "HorizontalSuiteCardBase-module_card-selected__fCoCC",
  p = "HorizontalSuiteCardBase-module_card-blurred__4-Nqk",
  C = "HorizontalSuiteCardBase-module_footer__I6O9r",
  B = "HorizontalSuiteCardBase-module_promo-box__kh0FH",
  S = {
    card: e,
    image: o,
    imageInner: r,
    imageFooter: t,
    title: a,
    features: i,
    pricesColumn: l,
    columnTitle: n,
    prices: d,
    priceItemInner: _,
    priceItemWrapper: c,
    priceItem: s,
    fareLabel: u,
    cardSelected: m,
    cardBlurred: p,
    footer: C,
    promoBox: B
  };
export { S as s };